import { render, staticRenderFns } from "./TranslateModule.vue?vue&type=template&id=5efb94e1&scoped=true"
import script from "./TranslateModule.vue?vue&type=script&lang=js"
export * from "./TranslateModule.vue?vue&type=script&lang=js"
import style0 from "./TranslateModule.vue?vue&type=style&index=0&id=5efb94e1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb94e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5efb94e1')) {
      api.createRecord('5efb94e1', component.options)
    } else {
      api.reload('5efb94e1', component.options)
    }
    module.hot.accept("./TranslateModule.vue?vue&type=template&id=5efb94e1&scoped=true", function () {
      api.rerender('5efb94e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/TranslateModule.vue"
export default component.exports